import { DbFile } from "../../core/DbFile";

export class UpdatePendingNewsRequest {
    ArticleId: number;
    ArticleTitle: string;
    ArticleContent: string;
    ImageId: string;
    RunDate: string;
    IsPortrait: boolean;
}